<template>
    <v-dialog :value="dialogVisible" @input="updateDialog" max-width="600">
        <v-card v-if="!loadingInstallments">
            <v-card-title class="headline">Simulador</v-card-title>
            <v-card-text class="text-body-2 text-grey-darken-1">
                {{ $t('modules.admission.preregistration.create.installmentSimulator.monthlyAmount') }}
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text class="pa-10-20">
                <v-table class="d-flex flex-column">
                    <thead>
                        <tr class="d-flex">
                            <th style="width: 40%;" class="text-left"> {{
                                $t('modules.admission.preregistration.create.installmentSimulator.detail') }}</th>
                            <th style="width: 30%;" class="text-right">{{
                                $t('modules.admission.preregistration.create.installmentSimulator.amount') }}</th>
                            <th style="width: 30%;" class="text-right">{{
                                $t('modules.admission.preregistration.create.installmentSimulator.paymentDate') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="d-flex" v-for="(installment, index) in installmentDetails" :key="index">
                            <td style="width: 40%;">{{ installment.description }}</td>
                            <td style="width: 30%;" class="text-right">{{ formatCurrency(installment.amount) }}</td>
                            <td style="width: 30%;" class="text-right">{{ formatDate(installment.dueDate) }}</td>
                        </tr>
                    </tbody>
                </v-table>
            </v-card-text>
            <v-card-text class="pa-10-20">
                <div class="d-flex justify-space-between align-center">
                    <span> {{ $t('modules.admission.preregistration.create.installmentSimulator.inscriptionCost')
                        }}</span>
                    <span class="font-weight-bold">{{ formatCurrency(singlePaymentCost) }}</span>
                </div>
                <div class="text-caption text-grey-darken-1">{{
                    $t('modules.admission.preregistration.create.installmentSimulator.singlePayment') }}
                </div>
            </v-card-text>
            <v-card-text class="pa-10-20">
                <div class="d-flex justify-space-between align-center">
                    <span>{{ $t('modules.admission.preregistration.create.installmentSimulator.amountToPay') }}</span>
                    <span class="font-weight-bold">{{ formatCurrency(computedTotal) }}</span>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="info" @click="closeDialog"> {{
                    $t('modules.admission.preregistration.create.installmentSimulator.close') }}</v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-else>
            <v-card-text>
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                {{ $t('modules.admission.preregistration.create.installmentSimulator.loading') }}
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    props: {
        dialogVisible: {
            type: Boolean,
            required: true
        },
        singlePaymentCost: {
            type: Number,
            required: true
        },
        total: {
            type: Number,
            required: true
        },
        saving: Number,
        selectedInstallments: {
            type: Number,
            required: true
        },
        installmentDetails: {
            type: Array,
            required: true
        },
        loadingInstallments: {
            type: Boolean,
            required: true
        },
        installmentError: {
            type: String,
            default: null
        }
    },
    computed: {
        computedTotal() {
            return this.saving != null ? this.total + this.saving : this.total;
        }
    },
    methods: {
        formatCurrency(amount) {
            return new Intl.NumberFormat('es-ES', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2
            }).format(amount)
        },
        formatDate(date) {
            return new Date(date).toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            })
        },
        closeDialog() {
            this.$emit('update:dialogVisible', false)
        },
        updateDialog(value) {
            this.$emit('update:dialogVisible', value)
        },
    }
    
}
</script>

<style scoped>
.pa-10-20 {
    padding: 10px 20px;
}
</style>